var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { findIndex } from "lodash";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { createReducer } from "typesafe-actions";
import "../epics/index.js";
import { appendIsolationGroup, replaceIsolationGroup } from "../epics/actions.js";
import { loadIsolationGroupsEpicReducer, loadAssignmentUnitsEpicReducer, loadAssignmentScopesEpicReducer } from "../epics/epics.js";
const defaultReducerState = {
  isolationGroups: getDefaultAsyncWrapperObj(),
  assignmentUnits: getDefaultAsyncWrapperObj(),
  assignmentScopes: getDefaultAsyncWrapperObj()
};
const actionsReducer = createReducer(defaultReducerState).handleAction(appendIsolationGroup, (state, action) => __spreadProps(__spreadValues({}, state), {
  isolationGroups: __spreadProps(__spreadValues({}, state.isolationGroups), {
    data: [...state.isolationGroups.data || [], action.payload]
  })
})).handleAction(replaceIsolationGroup, (state, action) => {
  const items = [...state.isolationGroups.data || []];
  const index = findIndex(items, (item) => item.id === action.payload.id);
  if (index < 0) {
    items.push(action.payload);
  } else {
    items[index] = action.payload;
  }
  return __spreadProps(__spreadValues({}, state), {
    isolationGroups: __spreadProps(__spreadValues({}, state.isolationGroups), {
      data: items
    })
  });
});
const reducer = (state = defaultReducerState, action) => {
  state = loadIsolationGroupsEpicReducer.reduxChange(state, action);
  state = loadAssignmentUnitsEpicReducer.reduxChange(state, action);
  state = loadAssignmentScopesEpicReducer.reduxChange(state, action);
  state = actionsReducer(state, action);
  return state;
};
export {
  actionsReducer,
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=ducks.js.map
